// @ts-nocheck
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';
import config from 'config';

import LogoPage from 'components/pages/LogoPage';
import { Focusable } from 'components/focus';

import WithLoading from 'components/common/WithLoading';
import QrCode from 'components/common/QrCode';

import { useFocusManager } from 'hooks/focus';
import { useFeedBackQrCode } from 'hooks/auth/qrCode';

import textToSpeechManager from 'support/tts/TextToSpeechManager';

import { useHistory } from 'react-router-dom';
import Button from 'components/common/Button';
import styles from './ContactUs.module.scss';

const messages = {
  contactUsLabel: {
    id: 'contactUs.label',
    description: 'contact us label',
  },
  contactUsCenterText: {
    id: 'contactUs.centerText',
    description: 'Text between email address and qr code',
  },
  contactUsEmailMessage: {
    id: 'contactUs.email.message',
    description: 'Text before email address',
  },
  qrCodeTextLine1: {
    id: 'contactUs.qrCode.line1',
    description: 'First line of text for qr code',
  },
  qrCodeTextLine2: {
    id: 'contactUs.qrCode.line2',
    description: 'Second line of text for qr code',
  },
  footerPrivacyText: {
    id: 'contactUs.footer.privacy.info',
    description: 'Privacy text in footer',
  },
  footerPrivacyButton: {
    id: 'contactUs.footer.privacy.button',
    description: 'Text in privacy button',
  },
};

const ContactUs = () => {
  const intl = useIntl();

  const ksLoading = useSelector(state => state.kitchenSink.loading);

  const focusManager = useFocusManager();
  useEffect(() => {
    focusManager.setCurrentFocus('privacy-policy-button');
  }, [focusManager]);

  useEffect(() => {
    textToSpeechManager.clear();
    textToSpeechManager.add(intl.formatMessage(messages.contactUsLabel));
    textToSpeechManager.add(intl.formatMessage(messages.contactUsEmailMessage));
    textToSpeechManager.add(config.contactEmail);

    textToSpeechManager.add(intl.formatMessage(messages.contactUsCenterText));
    textToSpeechManager.add(intl.formatMessage(messages.qrCodeTextLine1));
    textToSpeechManager.add(intl.formatMessage(messages.qrCodeTextLine2));
    textToSpeechManager.add(intl.formatMessage(messages.footerPrivacyText));
    textToSpeechManager.add(intl.formatMessage(messages.footerPrivacyButton));
    textToSpeechManager.speak();

    return () => {
      // stop current tts if reread
      textToSpeechManager.stop();
    };
  }, [intl]);

  const { qrCodeUrl } = useFeedBackQrCode();

  const history = useHistory();
  const onPrivacyPolicyClick = () => {
    history.push({
      pathname: '/legal',
    });
  };

  return (
    <Focusable
      focusId="contact-us-page"
      className="w-100 h-100"
      data-testid="contact-us-page"
      render={() => (
        <WithLoading loading={ksLoading}>
          <LogoPage className="position-relative">
            <div
              data-testid="message-content"
              className={classNames(
                'd-flex flex-column align-items-center',
                styles.messageContent,
              )}
            >
              <span className={styles.contactUsLabel}>
                <FormattedMessage {...messages.contactUsLabel} />
              </span>
              <div
                className={classNames(
                  'd-flex flex-row justify-content-center',
                  styles.mainRow,
                )}
              >
                <span
                  className={classNames(
                    'd-flex flex-row align-items-center',
                    styles.leftContent,
                  )}
                >
                  <span className={styles.message}>
                    <FormattedMessage {...messages.contactUsEmailMessage} />
                    <div
                      className={classNames(
                        'font-weight-bold',
                        styles.contactUsEmail,
                      )}
                    >
                      {config.contactEmail}
                    </div>
                  </span>
                </span>
                <span
                  className={classNames(
                    'd-flex justify-content-center',
                    styles.centerContent,
                  )}
                >
                  <span className={styles.centerText}>
                    <FormattedMessage {...messages.contactUsCenterText} />
                  </span>
                  <div className={styles.divider} />
                </span>
                <span
                  className={classNames(
                    'd-flex flex-row align-items-center',
                    styles.rightContent,
                  )}
                >
                  <QrCode url={qrCodeUrl} />

                  <span
                    className={classNames(
                      'd-flex flex-column',
                      styles.qrCodeText,
                    )}
                  >
                    <span className="font-weight-bold">
                      <FormattedMessage {...messages.qrCodeTextLine1} />
                    </span>
                    <span className={styles.qrCodeTextLine2}>
                      <FormattedMessage {...messages.qrCodeTextLine2} />
                    </span>
                  </span>
                </span>
              </div>
              <div
                className={classNames('d-flex flex-row', styles.legalFooter)}
              >
                <FormattedMessage {...messages.footerPrivacyText} />

                <Button
                  type="button"
                  onClick={onPrivacyPolicyClick}
                  focusId="privacy-policy-button"
                  className={classNames('w-100 h-100', styles.button)}
                  ttsText={intl.formatMessage(messages.footerPrivacyButton)}
                >
                  <FormattedMessage {...messages.footerPrivacyButton} />
                </Button>
              </div>
            </div>
          </LogoPage>
        </WithLoading>
      )}
    />
  );
};

export default ContactUs;
